import { DateFormat } from '../../../types/functions/date-format-options';
/**
 * Returns the format string for the date format request.
 */
export function getDateFormatString(options) {
    const { formats, format } = options;
    switch (format) {
        case DateFormat.ISO:
            return formats.iso;
        case DateFormat.DateLong:
            return formats.dateLong;
        case DateFormat.DateShort:
            return formats.dateShort;
        case DateFormat.DateDefault:
            return formats.dateDefault;
        case DateFormat.TimeLong:
            return formats.timeLong;
        case DateFormat.TimeShort:
            return formats.timeShort;
        case DateFormat.TimeDefault:
            return formats.timeDefault;
        default:
            return format;
    }
}
//# sourceMappingURL=get-date-format-string.js.map